import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const RestaurantLayout = lazy(() => import("@/features/restaurant/layout/RestaurantLayout"));
const RestaurantDashboard = lazy(() => import("@/features/restaurant/pages/Dashboard"));
const RestaurantOrders = lazy(() => import("@/features/restaurant/pages/Orders"));
const RestaurantSetup = lazy(() => import("@/features/restaurant/pages/Setup"));
const RestaurantMenuManagement = lazy(() => import("@/features/restaurant/pages/Menu"));
const RestaurantAnalytics = lazy(() => import("@/features/restaurant/pages/Analytics"));
const RestaurantSettings = lazy(() => import("@/features/restaurant/pages/Settings"));
const RestaurantReviews = lazy(() => import("@/features/restaurant/pages/Reviews"));
const RestaurantCampaigns = lazy(() => import("@/features/restaurant/pages/Campaigns"));
const RestaurantBilling = lazy(() => import("@/features/restaurant/pages/Billing"));

export const restaurantRoutes = (
  <>
    <Route path="/restaurant" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantDashboard /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/orders" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantOrders /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/menu" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantMenuManagement /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/analytics" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantAnalytics /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/settings" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantSettings /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/setup" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantSetup />
      </ProtectedRoute>
    } />
    <Route path="/restaurant/reviews" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantReviews /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/campaigns" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantCampaigns /></RestaurantLayout>
      </ProtectedRoute>
    } />
    <Route path="/restaurant/billing" element={
      <ProtectedRoute allowedRoles={['restaurant_owner']}>
        <RestaurantLayout><RestaurantBilling /></RestaurantLayout>
      </ProtectedRoute>
    } />
  </>
);
